import { useEffect } from "react";

const Contacto = () => {
    useEffect(() => {
        document.querySelector("nav").style.display = "none";
    }, []);
    
    return (
        <>
            <iframe src={"https://rjknack.000webhostapp.com/contacto/"} style={{
                height: "100vh",
                width: "100vw",
            }} id={"contacto-rjknack"}>
            </iframe>
        </>
        
    );
};

export default Contacto;